"use client";

import { isLocalEnvironment } from "@watt/common/utils/is-production-environment";
import { useDevtoolsStore } from "@watt/crm/store/devtools";
import { Accordion } from "@watt/ui/components/ui/accordion";
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from "@watt/ui/components/ui/popover";
import { Wrench } from "lucide-react";
import { DevtoolsSection } from "./devtools-section";
import { DEVTOOLS_SECTIONS } from "./devtools-sections";

export function DevtoolsPanel() {
  if (!isLocalEnvironment()) {
    return null;
  }

  return <DevtoolsPanelContent />;
}

function DevtoolsPanelContent() {
  const openSectionIds = useDevtoolsStore.use.openSectionIds();
  const setOpenSectionIds = useDevtoolsStore.use.setOpenSectionIds();

  return (
    <div
      className="pointer-events-auto fixed right-4 bottom-4 z-[9999]"
      data-local-devtools=""
    >
      <Popover>
        <PopoverTrigger
          aria-label="Open local developer tools"
          className="flex h-10 w-10 items-center justify-center rounded-full border bg-background text-foreground shadow-md transition-colors hover:bg-accent hover:text-accent-foreground"
        >
          <Wrench className="h-4 w-4" />
        </PopoverTrigger>
        <PopoverContent
          align="end"
          className="pointer-events-auto z-[9999] max-h-[min(80vh,640px)] w-80 overflow-y-auto"
          // Avoid fighting the drawer's focus trap; keep the popover usable over modals.
          onOpenAutoFocus={event => {
            event.preventDefault();
          }}
          side="top"
        >
          <div className="space-y-2">
            <div>
              <p className="font-medium text-sm">Local Devtools</p>
              <p className="text-muted-foreground text-xs">
                Tools available only in the local environment.
              </p>
            </div>
            <Accordion
              onValueChange={setOpenSectionIds}
              type="multiple"
              value={openSectionIds}
            >
              {DEVTOOLS_SECTIONS.map(({ id, title, description, Content }) => (
                <DevtoolsSection
                  description={description}
                  key={id}
                  title={title}
                  value={id}
                >
                  <Content />
                </DevtoolsSection>
              ))}
            </Accordion>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
}
